// Git blob SHA-1 (SPEC §4): sha1("blob <byte length>\0" + bytes), via Web Crypto.
// Matches the `sha` GitHub reports for blobs and `git hash-object`.

const encoder = new TextEncoder();

export async function gitBlobSha(bytes: Uint8Array): Promise<string> {
  const header = encoder.encode(`blob ${bytes.byteLength}\0`);
  const buf = new Uint8Array(header.byteLength + bytes.byteLength);
  buf.set(header, 0);
  buf.set(bytes, header.byteLength);
  const digest = await crypto.subtle.digest('SHA-1', buf);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const gitBlobShaOfText = (text: string) => gitBlobSha(encoder.encode(text));
